interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  schemaData?: Record<string, unknown>;
}

export default function SEO({ title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogImage, ogType = 'website', schemaData }: SEOProps) {
  const siteName = '韩漫网';
  const defaultTitle = '韩漫网 - 免费韩漫 - 漫画大全 - 在线韩国漫画';
  const defaultDescription = '欢迎访问韩漫网，您的专属韩漫宝藏库。我们承诺所有资源均为免费韩漫，并打造了最完善的漫画大全系统。专注于提供高清流畅的在线韩国漫画阅读服务。';
  const defaultKeywords = '韩漫网,免费韩漫,漫画大全,在线韩国漫画,韩漫,免费看漫画,韩国漫画,在线阅读';

  const finalTitle = title ? `${title} - ${siteName}` : defaultTitle;
  const finalDescription = description || defaultDescription;
  const finalKeywords = keywords || defaultKeywords;
  const finalCanonical = canonicalUrl || 'http://gxzzmm66.cn/';
  const finalOgImage = ogImage || 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20website%20brand%20image%20with%20warm%20atmosphere%20clean%20design%20reading%20theme%20soft%20lighting%20modern%20layout&width=1200&height=630&seq=og-default&orientation=landscape';

  return (
    <>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <link rel="canonical" href={finalCanonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={ogTitle || finalTitle} />
      <meta property="og:description" content={ogDescription || finalDescription} />
      <meta property="og:url" content={finalCanonical} />
      <meta property="og:image" content={finalOgImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || finalTitle} />
      <meta name="twitter:description" content={ogDescription || finalDescription} />
      <meta name="twitter:image" content={finalOgImage} />
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      )}
    </>
  );
}